/* src/app/features/contratacao/devolucao/pesquisa/listagem/devolucao-honra-listagem.component.scss */
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=devolucao-honra-listagem.component.css.map */
